export interface CatalogPageState {
    category: any;
}

export const initialCatalogPageState: CatalogPageState = {
    category: null
};
